import $ from "jquery";
import { cleanDITA } from './dita-clean.js';
import localforage from 'localforage';

let apiHost = "https://ccmsfiles.tg.org.au/";
// apiHost = "http://localhost:8000/";

export async function fetchToken() {
  // disabled auth for now
    return { data : "Bearer eyJ0eXAiOiJKV1QiLCJub25jZSI6ImJoSz"};
}

function getMimeType(fileName) {
  const textExtensions = ['txt', 'dita', 'ditamap', 'xml', 'json'];
  const extension = fileName.split('.').pop().toLowerCase();
  return textExtensions.includes(extension) ? 'string' : 'base64';
}

function getFileType(extension) {
  const binaryExtensions = {
    '.pdf': 'application/pdf',
    '.jpg': 'image/jpeg',
    '.png': 'image/png',
    '.jpeg': 'image/jpeg',
    '.svg': 'image/svg+xml',
  };
  return binaryExtensions[extension];
}

export async function fetchFileFromZip(contentFile,zip){
    contentFile = (contentFile.startsWith("/quicklinks"))?contentFile.slice(1):contentFile;
    //console.log(104,contentFile);
    const mimeType =  getMimeType(contentFile);
    const fileContent = await zip.file(contentFile).async(mimeType);
    const dataUri =(mimeType==="string")?fileContent: `data:${getFileType("."+contentFile.split(".").pop())};base64,${fileContent}`;

     //console.log(mimeType,fileContent,dataUri);

    contentFile = contentFile.split("/");
    if(contentFile.indexOf("quicklinks/") === -1){
      contentFile.shift(); // remove parent folder
    }
    contentFile = contentFile.join("/");
    let cleanDita = dataUri;

    try {
      if(mimeType==="string"){
          cleanDita = cleanDITA(cleanDita,contentFile);
      }
        // console.log(100,"=>Zip=>",mimeType,cleanDita,dataUri);
        console.log(100,"=>Zip=>",contentFile);
        // WriteToIDB(contentFile,cleanDita);
        return({data:cleanDita});
    } catch (err) {
        console.error(`Error storing file: ${contentFile}`, err);
    }
  // });
}

export function fetchData(sp) {
  return new Promise((resolve) =>{
    //https://graph.microsoft.com/v1.0/sites/589c23d3-622d-43d3-9ac3-ca4cad4566b4/drive/root:/Wilderness_Medicine/altitude-illness.dita
    //https://tgfoundation.sharepoint.com/:u:/s/Guidelines/EdRbDP31eGtHm_UpCT3OKiwBYHYENZcClLLf5QWjfS5PNw?e=cZh1qo
    //https://cors-anywhere.herokuapp.com/https://graph.microsoft.com/v1.0/sites/589c23d3-622d-43d3-9ac3-ca4cad4566b4/drive/items/01SHLLBQ6ULMGP35LYNNDZX5JJBE644KRM/content
    //01SHLLBQ4KDFMTEMEEHBCYDB7GQQ5VVIZO
    //https://cors-anywhere.herokuapp.com/https://graph.microsoft.com/v1.0/sites/589c23d3-622d-43d3-9ac3-ca4cad4566b4/drive/root:/Wilderness_Medicine/altitude-illness.dita:/content
    // console.log(sp);

    let headers = {};

    apiHost =
      "https://ccmsfiles.tg.org.au/" +
      sp.dartSelectors.ccmsversion?.selected +
      "/";
    let fileURL = apiHost+sp.guideline+sp.topicfile;
    fileURL = fileURL.replace(sp.guideline+sp.guideline,sp.guideline);

    if(apiHost.indexOf("tglcontent")>-1)fileURL = fileURL.replace(sp.guideline,sp.guideline.replace(/_/g,"%20")); 
    // console.log(sp.guideline); load from beta.


    if(sp.topicfile.indexOf(".txt")>-1){
      if(localStorage.getItem("localtoc")!==null){//enable to R&D preprocessing.
        fileURL="https://cdn.ckeditor.com/Guidelines/preprocess/"+sp.topicfile.replace(".xml",".txt"); /*console.log(fileURL);*/
        headers={};
      }else{
        fileURL=apiHost+"preprocess/"+sp.topicfile.replace(".xml",".txt");
      }
    }

    if(sp.dartSelectors.uxPlatform==="mobile" && sp.dartSelectors.ccmsversion.selected!=="main"){ // copied preprocess into staticcontent offline zip aws tag.
      fileURL = fileURL.replace("preprocess/","staticcontent/preprocess/");
    }
    
    fileURL = fileURL.replace("//quicklinks","/quicklinks").replace(".txt",".txt"); // remove doubleslashes appearing on quicklinks. TODO: find out why?
    // if(window.location.href.indexOf("localhost/")>-1){console.log(162,"counterAPI-fileURL:",fileURL);}
    // // alert("176,counterapi:fileURL="+fileURL);
    // fileURL = fileURL.replace('https://ccmsfiles.tg.org.au/','/').replace('https://api.tg.org.au/','/')
    // fileURL = fileURL.replace('https://ccmsfiles.tg.org.au/','//localhost/').replace('https://api.tg.org.au/','/localhost/')
    // console.log(fileURL);
    $.ajax({
      type: "GET",
      url: fileURL,
      crossDomain: true,
      headers,
      success: function (data) {
        // if(sp.topicfile.indexOf(".xml")>-1)console.log("Ajax response:", data);
        // console.log(171,"counterapi:::",JSON.stringify(data));
      },
      error: function (data, error, status) {
        // console.log(sp.topicfile,JSON.stringify(data), error, status);
        // console.log("184,counterapi-status:"+status);
      },
    }).then(function (data) {
      try{data = new XMLSerializer().serializeToString(data);}catch(e){}
      data = cleanDITA(data,fileURL);
      // console.log(data);

      // let writekey=sp.topicfile;
      // if(data.indexOf("Request failed with status code 429")>-1){
      //   writekey = "Error_"+writekey
      // }else{
      //   WriteToIDB(writekey,data);
      // }
      resolve({ data })
    });

    }
  );
}

export class CacheManager {
  constructor(config) {
    console.log("iDB", config);
    localforage.config(config);
  }

  keyFile = (key) =>
    key.indexOf("/") === -1 ? key : key.split("/").slice(-1)[0];

  write = (key, data) => localforage.setItem(this.keyFile(key), data);
  read = (key) => localforage.getItem(this.keyFile(key));
  remove = (key) => localforage.removeItem(this.keyFile(key));
  clear = () => localforage.clear();
  keys = () => localforage.keys();
  config = (config) => localforage.config(config);
}
